// frontend/src/pages/PaychequeList/helpers.ts
// Pure helpers: no React, no state, no DOM. Trivially unit-testable.

export const API_URL: string =
  process.env.REACT_APP_API_URL || "https://api.getnovala.com";

export function fmtDate(iso?: string | null): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  const dd = String(d.getUTCDate()).padStart(2, "0");
  const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
  return dd + "/" + mm + "/" + d.getUTCFullYear();
}

export function fmtMoney(v: number | string | null | undefined): string {
  const n = Number(v || 0);
  return "$" + n.toLocaleString("en-CA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function numberToWords(n: number | string | null | undefined): string {
  const value = Number(n || 0);
  const num = Math.floor(Math.abs(value));
  const cents = Math.round((Math.abs(value) - num) * 100);
  const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
  const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
  function under1000(x: number): string {
    if (x < 20) return ones[x];
    if (x < 100) return tens[Math.floor(x / 10)] + (x % 10 ? "-" + ones[x % 10].toLowerCase() : "");
    return ones[Math.floor(x / 100)] + " hundred" + (x % 100 ? " " + under1000(x % 100).toLowerCase() : "");
  }
  let words = "";
  if (num === 0) words = "Zero";
  else if (num < 1000) words = under1000(num);
  else if (num < 1000000) {
    words = under1000(Math.floor(num / 1000)) + " thousand";
    if (num % 1000) words += " " + under1000(num % 1000).toLowerCase();
  } else {
    words = under1000(Math.floor(num / 1000000)) + " million";
    if (Math.floor((num % 1000000) / 1000)) words += " " + under1000(Math.floor((num % 1000000) / 1000)).toLowerCase() + " thousand";
    if (num % 1000) words += " " + under1000(num % 1000).toLowerCase();
  }
  return words + " and " + String(cents).padStart(2, "0") + "/100 DOLLARS";
}

export function authHeaders(): Record<string, string> {
  const t =
    localStorage.getItem("access_token") ||
    localStorage.getItem("token") ||
    "";
  return {
    Authorization: "Bearer " + t,
    "Content-Type": "application/json",
  };
}

export function initialsOf(name?: string | null): string {
  if (!name) return "?";
  const parts = String(name).trim().split(/\s+/);
  return (
    (parts[0]?.[0] || "") + (parts[parts.length - 1]?.[0] || "")
  ).toUpperCase();
}